import React from "react";
import { Grid, Button } from "@mui/material";

const HomeNav = ({
  activeButton,
  handleOpenStepperDialog,
  handleOpenLogsDialog,
  handleComponentSelection,
  allowedUsers,
  currentUser,
}) => (
  <Grid container spacing={2}>
    <Grid item>
      <Button variant="contained" className="button" onClick={handleOpenStepperDialog}>
        New Extraction Rule
      </Button>
    </Grid>
    <Grid item>
      <Button
        variant="contained"
        className={activeButton === "FolderList" ? "button active" : "button"}
        onClick={() =>
          allowedUsers.includes(currentUser.uid)
            ? handleComponentSelection("FolderList", "FolderList")
            : alert("Access Denied: You do not have permission to view Extraction Rules.")
        }
      >
        View Extraction Rules
      </Button>
    </Grid>
    <Grid item>
      <Button
        variant="contained"
        className={activeButton === "DownloadRulePicker" ? "button active" : "button"}
        onClick={() =>
          allowedUsers.includes(currentUser.uid)
            ? handleComponentSelection("DownloadRulePicker", "DownloadRulePicker")
            : alert("Access Denied: You do not have permission to view Download Rules.")
        }
      >
        Download Rules
      </Button>
    </Grid>
    <Grid item>
      <Button
        variant="contained"
        className={activeButton === "PreDefinedRulesManager" ? "button active" : "button"}
        onClick={() =>
          allowedUsers.includes(currentUser.uid)
            ? handleComponentSelection("PreDefinedRulesManager", "PreDefinedRulesManager")
            : alert("Access Denied: You do not have permission to view PreDefined Rules Manager.")
        }
      >
        PreDefined Rules Manager
      </Button>
    </Grid>
    <Grid item>
      <Button
        variant="contained"
        className={activeButton === "MailboxRuleManager" ? "button active" : "button"}
        onClick={() =>
          allowedUsers.includes(currentUser.uid)
            ? handleComponentSelection("MailboxRuleManager", "MailboxRuleManager")
            : alert("Access Denied: You do not have permission to view Mailbox Rules.")
        }
      >
        Mailbox Rules
      </Button>
    </Grid>
    <Grid item>
      <Button
        variant="contained"
        className={activeButton === "LogsDialog" ? "button active" : "button"}
        onClick={handleOpenLogsDialog}
      >
        View Logs
      </Button>
    </Grid>
    <Grid item>
      <Button
        variant="contained"
        className={activeButton === "PDownloadLogs" ? "button active" : "button"}
        onClick={() =>
          allowedUsers.includes(currentUser.uid)
            ? handleComponentSelection("DownloadLogs", "DownloadLogs")
            : alert("Access Denied: You do not have permission to download logs.")
        }
      >
        Download Logs
      </Button>
    </Grid>
  </Grid>
);

export default HomeNav;
